import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { DataTableBooking } from 'modules/space_control/hooks/bookings/dataTableBooking'

import BookingsPopoverMenu from './Menu'

interface Props {
  booking: DataTableBooking
  canEditEverybody: boolean
  canEditSelf: boolean
  canCancelEverybody: boolean
  canCancelSelf: boolean
}
const BookingsActionButtons = ({
  booking,
  canEditEverybody,
  canEditSelf,
  canCancelEverybody,
  canCancelSelf,
}: Props) => {
  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd" paddingRight="s24">
      <BookingsPopoverMenu
        booking={booking}
        canEditEverybody={canEditEverybody}
        canEditSelf={canEditSelf}
        canCancelEverybody={canCancelEverybody}
        canCancelSelf={canCancelSelf}
      />
    </Box>
  )
}

export default observer(BookingsActionButtons)
